import React from 'react';
import{Grid,Box,Stack,Typography} from '@mui/material';
import Progress from '../Progress/Progress';
import BackGround from '../Login/Statics/Imgs/bg3.png'

import {ReactComponent as Img1} from '../Loading/svg/Group 4242492.svg';
import {ReactComponent as Img2} from '../Loading/svg/MainLogoOKR.svg';
import {ReactComponent as Img3} from '../Loading/svg/Group 4242492.svg';
import {ReactComponent as OKRText} from '../Loading/svg/OKRText.svg';

import mainLgo from '../Loading/svg/logo192.png'


const Loading = ({setContentState,loading}:any) => {
  return (
//     <Grid container sx={{
     
//        minHeight:'100vh',
//         overflowY:'auto',
//         backgroundImage:`url(${BackGround})`,
//         backgroundSize:'cover'
//     }}   >
// <Stack spacing={2} alignItems='center'  justifyContent='center'  sx={{width:'600px',height:'100%'}} mx="auto" >

// <Box width='100%' >
// <Box  mx={'auto'}  mt={10}  display={'flex'} justifyContent={'center'}>
// <Img2 onClick={()=>{
// // confirm('test')
// }} style={{width:'400px'}} />
// </Box>
// </Box>
// <Box>
//   <OKRText/>
//   </Box>
  
// <Box height={'40px'}>
// </Box>

// <Box
//   sx={{
//     background: 'linear-gradient(135deg, rgba(173, 216, 230, 0.7), rgba(135, 206, 250, 0.7))', // گرادینت یخی
//     padding: '5px 10px', // فاصله داخلی
//     borderRadius: '5px', // گوشه‌های گرد
//     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)', // سایه برای عمق بیشتر
//     display: 'inline-block', // به متن اجازه می‌دهد در کنار هم قرار بگیرد
//   }}
// >
//   <Typography color={'white'} fontWeight={550} fontSize={'11px'}>
//     ورژن 1.3.6
//   </Typography>
// </Box>

// <Box sx={{width:'150px',textAlign:'center'}} mt={2} >
// {
// loading && <Progress setContentState={setContentState} />
// }
// </Box>
// </Stack>
//     </Grid>
<Grid
  container
  sx={{
    minHeight: '100vh',
    overflowY: 'auto',
    backgroundImage: `url(${BackGround})`,
    backgroundSize: 'cover',
    padding: { xs:0, sm: 4 },
  }}
>
  <Stack
    spacing={2}
    alignItems="center"
    justifyContent="center"
    sx={{
      width: { xs: '100%', sm: '600px' },
      height: '100%',
      display: { xs: 'none', sm: 'flex' }, // پنهان‌سازی کل محتوا در موبایل
    }}
    mx="auto"
  >
    <Box width="100%">
      <Box
        mx="auto"
        mt={10}
        display="flex"
        justifyContent="center"
      >
        <Img2
          onClick={() => {
            // confirm('test')
          }}
          style={{ width: '100%', maxWidth: '400px' }}
        />
      </Box>
    </Box>

    <Box>
      <OKRText />
    </Box>

    <Box height="40px" />

    <Box
      sx={{
        background: 'linear-gradient(135deg, rgba(173, 216, 230, 0.7), rgba(135, 206, 250, 0.7))',
        padding: '5px 10px',
        borderRadius: '5px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        display: 'inline-block',
        marginTop: 2,
      }}
    >
      <Typography color="white" fontWeight={550} fontSize="11px">
        ورژن 1.3.6
      </Typography>
    </Box>

    {/* <Box sx={{ width: '150px', textAlign: 'center' }} mt={2}>
      {loading && <Progress setContentState={setContentState} />}
    </Box> */}
  </Stack>
  </Grid>

  )
}

export default Loading
//////////////////////////////////////////////////////////////////////////////////////////
// import React from 'react';
// import{Grid,Box,Stack,} from '@mui/material';
// import Progress from '../Progress/Progress';
// import BackGround from '../Login/Statics/Imgs/bg3.png'

// import {ReactComponent as Img1} from '../Loading/svg/Group 4242492.svg';
// import {ReactComponent as Img2} from '../Loading/svg/MainLogoOKRR.svg';
// import {ReactComponent as Img3} from '../Loading/svg/Group 4242492.svg';
// import {ReactComponent as OKR} from '../Loading/svg/OKR.svg';
// import {ReactComponent as Omid} from '../Loading/svg/Omid.svg';
// import mainLgo from '../Loading/svg/logo192.png'


// const Loading = ({setContentState,loading}:any) => {
//   return (
//     <Grid overflow={'hidden'} container sx={{
     
//         minHeight:'100vh',
//         overflowY:'auto',
//         backgroundImage:`url(${BackGround})`,
//         backgroundSize:'cover'
//     }}   >
// <Stack  alignItems='center'  justifyContent='center'  sx={{width:'555px',height:'100%'}}>

// {/* <Box>
// <Img1/>

// </Box> */}

// {/* <Box sx={{width:'150px',textAlign:'center'}} mt={2} >
// {
// loading && <Progress setContentState={setContentState} />
// }

// </Box> */}
// <Box  display={'flex'} margin={5} flexDirection={'column'} justifyContent={'center'} marginRight={2} >
//   <Omid/>
//   </Box>

// <Box display={'flex'} alignItems={'center'} marginTop={10} flexDirection={'column'}  justifyContent={'center'}>
//  <a target='-blank' href='https://okrcoach.ir/'> <Img2/></a>
//  <a target='-blank' href='https://okrcoach.ir/'> <OKR/></a>
// </Box>


// </Stack>     

//     </Grid>
    
//   )
// }

// export default Loading